
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DialogPendingReport',
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:open']
})
